/**
 * space_claims.ts — the WORDS for a kill the server could not see (space campaign L, 2026-10-01; space.md §14 gap 29,
 * report §21.5). Pure.
 *
 * Patrols, wings, void raiders, ambush raiders and the war's gunship POOL have no server body: their deaths are the
 * client's word, bounded only by the reducers' budgets. Wherever such a kill is SHOWN or PAID it now says so, with its
 * cap — and a den slot (`spaceHit` judged the killing blow, `serverKill`) or a validated war life says the record judged
 * it. The caps are the server's own constants, quoted (the harness pins them against the reducer source):
 *   spaceKill      — `KILL_REPORTS_PER_MIN` 20 a rolling minute (reducers/space.ts), one bounty per slot per respawn
 *   ambushKill     — one claim per raider, the ambush's own living count (reducers/space_economy.ts)
 *   campaignKill   — `CAMPAIGN_KILLS_PER_MIN` 20 a minute; in a PINNED war `GUNSHIP_CLAIM_CAP` 10 gunships a pilot
 *                    (slice D) — the after-action record already labels those (D's work, not repeated)
 *   incursionKill  — `INCURSION_KILLS_PER_MIN` 12 a minute (counted toward the grip, never paid)
 * Patrols and wingmen are never paid and send nothing.
 */

export const KILL_REPORTS_PER_MIN = 20;
export const CAMPAIGN_KILLS_PER_MIN = 20;
export const INCURSION_KILLS_PER_MIN = 12;
export const GUNSHIP_CLAIM_CAP = 10;

export type ClaimKind = 'void' | 'ambush' | 'gunship' | 'gunshipPinned' | 'den';

/** The short tag a toast / HUD line carries. */
export function claimTag(kind: ClaimKind): string {
  switch (kind) {
    case 'void': return `claim-based · ≤ ${KILL_REPORTS_PER_MIN}/min`;
    case 'ambush': return 'claim-based · one per raider';
    case 'gunship': return `claim-based · ≤ ${CAMPAIGN_KILLS_PER_MIN}/min`;
    case 'gunshipPinned': return `claim-based · ≤ ${GUNSHIP_CLAIM_CAP} a war`;
    case 'den': return 'judged by the record';
  }
}

/** A kill toast with its label: "Raider destroyed — 15 ⓒ bounty (claim-based · ≤ 20/min) (45 this run)". */
export function claimToast(kind: ClaimKind, head: string, tail = ''): string {
  return `${head} (${claimTag(kind)})${tail ? ` ${tail}` : ''}`;
}
